var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",attrs:{"id":"pegasus"}},[_c('div',{staticClass:"col"},[_c('h3',{staticClass:"game-heading text-white mb-4"},[_vm._v("Pegasus")]),_c('fish-shooting',{attrs:{"games":this.pegasusFsGames}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }